<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="d-flex m-3 w-100 justify-content-between">
        <p class="fw-bold">
          پایش و مراقبت دستگاه/ {{$route.params.title}}
        </p>

        <div>

        <button style="transform: translateX(3vw)" class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>

        </div>

      </div>

     <div class="d-flex justify-content-between p-2">
       <div></div>
       <div class="d-flex changer">
         <p>
           اقدام  پشتیبان
         </p>
         <router-link :to="`/problem_analysis/device_monitoring_and_care/by/backup/${$route.params.id}/${$route.params.title}`">
           اقدام پیشران
         </router-link>
       </div>
     </div>

      <div v-if="isSplashVisible" class="splash ">
        <BehfamLOGO style="right: 5vw;" name="در حال بارگذاری"/>

      </div>
      <center  class="my-2">
        <p>نوع نمایش</p>
        <div class="d-flex  changer_btn">
          <p @click.prevent="toggleType(true)" :class="{'active' : type}">
            فعالیت ها
          </p>
          <p @click.prevent="toggleType(false)" :class="{'active_two' : !type}">
            سنجه ها
          </p>
        </div>

      </center>



      <Photographer v-if="type"/>
      <PhotographerVTwo_Sange v-else/>




    </div>
  </div>
</template>


<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import splash from "@/components/Splash/Splash.vue";
import SupportMeasures from "@/components/Definition_of_basic_measures/SupportMeasures.vue";
import Photographer from "@/components/device_monitoring_and_care/mother/Photographer.vue";
import BehfamLOGO from "@/components/Icons/BehfamLOGO.vue";
import router from "@/router";
import PhotographerVTwo from "@/components/device_monitoring_and_care/mother/PhotographerVTwo.vue";
import PhotographerVTwo_Sange from "@/components/device_monitoring_and_care/mother/PhotographerVTwo_Sange.vue";

export default {
  components: {
    PhotographerVTwo_Sange, PhotographerVTwo,
    BehfamLOGO,
    Photographer,


    Sidebar,
    splash
  },
  data() {
    return {
      id_route: this.$route['params']['id'],
      type: true,
      name: '',
      isSplashVisible: false,
    }
  },
  methods: {
    toggleType(newType) {
      if (newType) {
        this.name = 'فعالیت ها'
      } else {
        this.name = 'سنجه ها'

      }
      if (this.type !== newType) {
        this.isSplashVisible = true;  // نمایش Splash

        setTimeout(() => {
          this.type = newType;  // تغییر type بعد از تایم Splash
          this.isSplashVisible = false;  // پنهان کردن Splash
        }, 1000);  // زمان نمایش Splash (2000 میلی‌ثانیه = 2 ثانیه)
      }
    },
    checkIsMother() {
      if (!this.is_mother) {
        router.push('/pishkhan')
        return
      }

    }
  },

  mounted() {
    this.checkIsMother()
    this.toggleType(true)

  }

}
</script>
<style scoped lang="scss">
.changer{
  background-color: #AFAFAF;
  height: 2vw;
  border-radius: 1vw;
  width: 19vw;
  justify-content: space-evenly;
  &>p:nth-child(1){
    width: 11vw;
    height: 2vw;
    background-color: #3742FA;
    color: #fff;
    transform: translateX(.9vw);
    border-radius: 1vw;
  }
  &>p:nth-child(2){
    margin-left: 1vw;
  }  &>p {
       cursor: pointer;
       font-size: 1vw;
     }
  &>a{
    color: black;
    text-decoration: none;
    margin-left: .9vw;
  }
}
p {
  font-size: 1vw;
}
.changer_btn > p {
  transform: translateY(0.7vw);
  cursor: pointer; /* نشانگر ماوس تغییر کند */
  transition: all 0.3s ease; /* انیمیشن نرم */
  padding: 0; /* حذف فاصله اضافی */
}

.changer_btn > p.active,
.changer_btn > p.active_two {
  color: #fff;
  background-color: #3742FA;
  height: 2vw;
  border-radius: 1vw;
  transform: translateY(0.7vw);

}

.changer_btn > p.active {
  width: 11vw;
  transform: translateX(1.9vw) translateY(0.6vw);
}

.changer_btn > p.active_two {
  width: 8vw;
  transform: translateX(-2.4vw) translateY(0.6vw);
}

p {
  font-size: 1vw;
}

.changer {
  background-color: #AFAFAF;
  height: 2vw;
  border-radius: 1vw;
  width: 20vw;
  justify-content: space-evenly;

  & > p:nth-child(1) {
    width: 11vw;
    height: 2vw;
    background-color: #3742FA;
    color: #fff;
    transform: translateX(.9vw);
    border-radius: 1vw;
  }

  & > p {
    margin-left: 1vw;
  }

  & > p {
    cursor: pointer;
    font-size: 1vw;
  }

  & > a {
    color: black;
    text-decoration: none;
    margin-left: .9vw;
  }
}

p {
  font-size: 1vw;
}

.changer_btn {
  display: flex;
  background-color: #AFAFAF;
  height: 2vw;
  border-radius: 1vw;
  width: 17vw !important;
  justify-content: space-evenly;
  align-items: center; /* برای تراز عمودی */
}

.changer_btn > p {
  transform: translateY(0.7vw);
  cursor: pointer; /* نشانگر ماوس تغییر کند */
  transition: all 0.3s ease; /* انیمیشن نرم */
  padding: 0; /* حذف فاصله اضافی */
}

.changer_btn > p.active,
.changer_btn > p.active_two {
  color: #fff;
  background-color: #3742FA;
  height: 2vw;
  border-radius: 1vw;
  transform: translateY(0.7vw) translateX(-1.9vw);

}

.changer_btn > p.active {
  width: 11vw;
  transform: translateX(1.9vw) translateY(0.6vw);
}
</style>